import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import LazyRoute from '../components/LazyRoute'
import { TablePageLoader } from '@/components/ui/page-loader'

const searchSchema = z.object({
  bridge_id: z.string().optional(),
})

export const Route = createFileRoute('/_protected/events/outgoing')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/pages/EventsOutgoing')}
      fallback={<TablePageLoader />}
    />
  ),
  validateSearch: searchSchema,
})
